import React from "react";
import { Card, CardBody, Col, Input, Label, Row, TabPane } from "reactstrap";
import moment from "moment";
import { isEmpty } from "lodash";

export default function Generals({
  dataAppointment,
  onChange,
  tabGenerals,
  isLoadingTabs,
  pageEdit,
  isPageModalHistory
}) {
  const yearAffiliate = dataAppointment?.patient?.dateOfBirth
    ? moment().diff(moment(dataAppointment?.patient?.dateOfBirth), "year")
    : "";

  if (isEmpty(dataAppointment) || isLoadingTabs || (pageEdit && !tabGenerals?.reason)) {
    return (
      <div className="animated fadeIn d-flex justify-content-center p-5">
        loading...
      </div>
    );
  }
    return (
      <TabPane tabId={1} className="p-0 m-0">
        <div className="animated fadeIn">
          <Card>
            <CardBody>
              <Row form>
                <Col md={3}>
                  <Label>Paciente:</Label>
                  <Input
                    value={dataAppointment?.patient?.fullname || ""}
                    disabled
                  />
                </Col>
                <Col md={2}>
                  <Label>Sexo:</Label>
                  <Input
                    value={dataAppointment?.patient?.gender?.name || ""}
                    disabled
                  />
                </Col>
                <Col md={2}>
                  <Label>Aseguradora:</Label>
                  <Input
                    value={dataAppointment?.patient?.ars?.name || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Label>Edad:</Label>
                  <Input value={yearAffiliate || ""} disabled />
                </Col>
              </Row>
              <Row form className="mt-4">
                <Col className="d-flex flex-column">
                  <Label>Motivo de la Consulta:</Label>
                  <Input
                  type="textarea"
                  disabled={isPageModalHistory}
                    onBlur={({ target: { value } }) =>
                      onChange("tabGenerals", value, "reason")
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.currentTarget.blur();
                    }}
                    defaultValue={tabGenerals?.reason || ""}
                  />
                </Col>
              </Row>
              <Row form className="mt-4">
                <Col className="d-flex flex-column">
                  <Label>Historia de la Enfermedad:</Label>
                  <Input
                  type="textarea"
                  disabled={isPageModalHistory}
                    onBlur={({ target: { value } }) =>
                      onChange("tabGenerals", value, "diseaseHistory")
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.currentTarget.blur();
                    }}
                    defaultValue={tabGenerals?.diseaseHistory || ""}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </TabPane>
    );
}
